<script>
export default {
  mounted(){
    localStorage.setItem('accessToken', "null")
    this.$router.push({name:'login'})
  },
}
</script>
